<template>
  <div class="categories-page">
    <CategoryBanner :banner="category.topBanner" class="is-hidden-mobile" />
    <AccordionsContainer
      :entity-type="entityType"
      :param-top-category="paramTopCategory"
      :param-category="paramCategory"
      :param-sub-category="paramSubCategory"
    />
    <ProductRecommendationsCarouselContainer
      v-if="showTopCategoryCarousel"
      :title="$t('carousel.recommendedForYou')"
      :products="productRecommendations"
      :products-per-view="5"
      entity-type="category"
      carousel-name="recommended_for_you"
    />
    <ProductsListingContainer
      entity-type="category"
      :entity-value="categorySlugUrl || ''"
      :param-top-category="paramTopCategory"
      :param-category="paramCategory"
      :param-sub-category="paramSubCategory"
    >
      <template #product-recommendations>
        <ProductRecommendationsCarouselContainer
          v-if="showSubCategoryCarousel"
          :title="$t('carousel.recommendedForYou')"
          :products="productRecommendations"
          :products-per-view="4"
          entity-type="category"
          carousel-name="recommended_for_you"
        />
      </template>
    </ProductsListingContainer>
    <SeoFooterContainer :footer-content="category.footerContent" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import seoMeta from '../../mixins/seoMeta'
import searchQueryIdCookieHelper from '../../mixins/searchQueryIdCookieHelper'
import AccordionsContainer from '../../components/AccordionsContainer.vue'
import CategoryBanner from '../../components/CategoryBanner.vue'
import ProductsListingContainer from '../../components/ProductsListingContainer.vue'
import SeoFooterContainer from '../../components/SeoFooterContainer.vue'
import ProductRecommendationsCarouselContainer from '../../components/ProductRecommendationsCarouselContainer.vue'

export default {
  name: 'Index',

  components: {
    AccordionsContainer,
    CategoryBanner,
    ProductsListingContainer,
    ProductRecommendationsCarouselContainer,
    SeoFooterContainer
  },

  mixins: [seoMeta, searchQueryIdCookieHelper],

  data() {
    return {
      // this is being used in seoMeta mixin
      entityType: 'category',
      paramTopCategory: '',
      paramCategory: '',
      paramSubCategory: ''
    }
  },

  async fetch() {
    const categoryPath = this._categoryPath().join('/')
    await this.$store.dispatch('listingPageCategory/fetchCategory', {
      categoryPath
    })
  },

  computed: {
    ...mapGetters({
      category: 'listingPageCategory/category',
      productRecommendations: 'productRecommendations/recommendations'
    }),
    showTopCategoryCarousel() {
      return (
        // Minimum 5 products are required to show the carousel
        this.productRecommendations.length > 4 &&
        !!this.paramTopCategory &&
        !this.paramCategory &&
        !this.paramSubCategory &&
        this.isCategoryPageValidForRecommendations(this.paramTopCategory)
      )
    },
    showSubCategoryCarousel() {
      return (
        this.isCategoryPageValidForRecommendations(this.paramTopCategory) &&
        !!this.paramCategory &&
        this.productRecommendations.length > 4
      )
    }
  },

  async mounted() {
    if (this.isCategoryPageValidForRecommendations(this.paramTopCategory)) {
      await this.fetchProductRecommendations()
    }
  },

  methods: {
    _categoryPath() {
      const { $route } = this
      const {
        topCategory = '',
        category = '',
        subCategory = ''
      } = $route.params

      this.paramTopCategory = topCategory
      this.paramCategory = category
      this.paramSubCategory = subCategory

      return [
        this.paramTopCategory,
        this.paramCategory,
        this.paramSubCategory
      ].filter((cat) => !!cat)
    },
    async fetchProductRecommendations() {
      await this.$store.dispatch(
        'productRecommendations/fetchProductRecommendations',
        {
          path: this.$route.path,
          recommendationsCount: 8
        }
      )
    },
    isCategoryPageValidForRecommendations(paramTopCategory) {
      const validTopLevelCategories = [
        'makeup',
        'hair',
        'skincare',
        'fragrance',
        'bath-and-body'
      ]
      return validTopLevelCategories.includes(paramTopCategory)
    }
  }
}
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
